const or = (a, b) => a || b;
export default or;
